export class AddressModule {
    gnAddressID: number = 0;
    name: string = '';
    parentID: number = 0;
    type: string = '';
    notes: string = '';
}
